import React from "react";
import './TopicCard.css'
import { Typography } from "antd";
import { useDarkMode } from 'src/context/DarkModeContext';
import { TopicModel } from "src/data/models/TopicModel";

const { Title } = Typography;

const TopicCard: React.FC<{ topic: TopicModel; onClick: () => void, className?: string }> = ({
  topic,
  onClick,
  className
}) => {


  const { isDarkMode } = useDarkMode();

  return (
    <div
      onClick={onClick}
      className={`topic-card ${className ? className : ''}`}
    >
      <div className={`topic-card-gradient ${topic.imageUrl}`}></div>

      <Title
        level={4}
        className={`topic-card-title ${isDarkMode ? 'dark-topic-card-title' : 'light-topic-card-title'}`}>

        {topic.title}
      </Title>
      <div className="hover-overlay"></div>
    </div>
  );
};

export default TopicCard;
